module.exports = __webpack_public_path__ + "fonts/Lato-Medium.acbd6ecc.woff";